<template>
    <b-card no-body class="mb-4">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0">
                    {{ $t("variants") }}
                </h5>
                <b-button
                    size="sm"
                    variant="primary"
                    class="btn-round"
                    @click="showVariantDialog = true"
                    v-if="$can('create variant')"
                >
                    <font-awesome-icon :icon="['fas', 'plus']" />
                    {{ $t("create_product_variant") }}
                </b-button>
                <product-variant-dialog
                    @saved="reloadProduct()"
                    :collection_id="product.collection.id"
                    :base_product_id="product.id"
                    v-model="showVariantDialog"
                />
            </div>
        </template>
        <b-card-body>
            <b-input-group class="mb-3 search-widget simple-search">
                <template #prepend>
                    <b-input-group-text>
                        <font-awesome-icon icon="search"></font-awesome-icon>
                    </b-input-group-text>
                </template>
                <b-form-input
                    type="search"
                    v-model="filterTerm"
                    :placeholder="$t('search_by_reference')"
                />
            </b-input-group>

            <b-table
                class="smartvault-variants-list"
                small
                striped
                hover
                :items="variants"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filterTerm"
                :filter-included-fields="['reference']"
            >
                <template v-slot:cell(attributes)="data">
                    <ul class="list-unstyled m-0">
                        <li v-for="attr in data.item.options" :key="attr.id">
                            <strong class="text-capitalize"
                                >{{ attr.name }}:</strong
                            >
                            {{ attr.value }}
                        </li>
                    </ul>
                </template>
                <template v-slot:cell(name)="data">
                    <div class="variant-name" v-if="data.item.name">
                        {{ data.item.name }}
                    </div>
                    <em class="variant-no-name text-muted" v-else>{{
                        $t("no_name")
                    }}</em>
                </template>
                <template v-slot:cell(controls)="data">
                    <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="editVariant(data.item)"
                        v-if="$can('edit variant')"
                    >
                        <font-awesome-icon :icon="['fas', 'pen']" />
                        {{ $t("edit") }}
                    </b-button>
                </template>
                <template v-slot:cell(delete)="data">
                    <b-button
                        size="sm"
                        variant="danger"
                        class="btn-lte"
                        @click="showDeleteDialog(data.item)"
                    >
                        <font-awesome-icon :icon="['fas', 'trash']" />
                    </b-button>
                </template>
            </b-table>

            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="variants.length"
                align="right"
                class="my-2"
            />

            <product-variant-dialog
                @saved="reloadProduct()"
                v-model="variantDialog.show"
                :collection_id="product.collection.id"
                :base_product_id="product.id"
                :id="variantDialog.id"
            >
            </product-variant-dialog>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ProductVariantDialog from "../EditDialogs/ProductVariantDialog";
import axios from "axios";

export default {
  name: "Variants",
  components: { ProductVariantDialog },
  props: {
    variants: Array
  },
  data() {
    return {
      filterTerm: "",
      currentPage: 1,
      perPage: 10,
      showVariantDialog: false,
      variantDialog: {
        show: false,
        base_product_id: null,
        id: null
      },
      fields: [
        {
          key: "reference",
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "attributes",
          label: this.$t("attributes"),
          sortable: true
        },
        {
          key: "name",
          sortable: false
        },
        {
          key: "controls",
          sortable: false
        },
        {
          key: "delete",
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapState("smartVaultProduct", {
      product: state => state.product,
      loading: state => state.loading
    }),
    ...mapGetters("smartVaultProduct", {
      variant: "getVariant"
    })
  },
  mounted() {},
  methods: {
    ...mapActions("smartVaultProduct", ["getProduct"]),
    editVariant(item) {
      this.variantDialog = {
        show: true,
        base_product_id: item.base_product_id,
        id: item.id
      };
    },
    showDeleteDialog(item) {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to product variant?", {
          title: this.title,
          okVariant: "danger",
          okTitle: this.$t("delete"),
          footerClass: "p-2",
          hideHeaderClose: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.deleteVariant(item);
          }
        });
    },
    deleteVariant(item) {
      axios
        .get(`/api/variants/${item.id}/has-order`)
        .then(resp => {
          if (resp.data.has_order) {
            axios.put("/api/variants/" + item.id + "/hide");
          } else {
            axios.delete("/api/variants/" + item.id);
          }

          this.product.variants.splice(this.product.variants.indexOf(item), 1);
        })
        .catch(error => {
          reject(error);
        });
    },
    reloadProduct() {
      this.getProduct(this.product.id);
    }
  }
};
</script>

<style scoped>
</style>
